import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.settings.ai');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import showdown from 'showdown';

@Component({
    selector: 'wiz-page-settings-ai',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.settings.ai/view.scss */
:host {
  display: block;
  height: 100%;
}

.ai-settings {
  min-height: 100%;
  background: #f6f7f9;
  color: #1f2937;
  overflow: auto;
}
.ai-settings button, .ai-settings input, .ai-settings select, .ai-settings textarea {
  font: inherit;
}
.ai-settings button {
  cursor: pointer;
}
.ai-settings button:disabled {
  cursor: default;
}
.ai-settings input, .ai-settings select, .ai-settings textarea {
  width: 100%;
  border: 1px solid #d6dbe3;
  border-radius: 8px;
  background: #ffffff;
  color: #111827;
  outline: none;
  transition: border-color 160ms ease, box-shadow 160ms ease, background 160ms ease;
}
.ai-settings input, .ai-settings select {
  min-height: 40px;
  padding: 0 12px;
  font-size: 13px;
}
.ai-settings textarea {
  min-height: 280px;
  padding: 12px;
  font-size: 13px;
  line-height: 1.65;
  resize: vertical;
}
.ai-settings input:focus, .ai-settings select:focus, .ai-settings textarea:focus {
  border-color: #0f766e;
  box-shadow: 0 0 0 3px rgba(15, 118, 110, 0.1);
}

.settings-shell {
  max-width: 1280px;
  margin: 0 auto;
  padding: 28px 24px 44px;
}

.settings-topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  margin-bottom: 18px;
}

.topbar-title {
  display: flex;
  align-items: center;
  gap: 14px;
  min-width: 0;
}
.topbar-title h1 {
  margin: 0;
  font-size: 24px;
  line-height: 1.2;
  font-weight: 750;
  color: #111827;
}

.title-mark {
  width: 44px;
  height: 44px;
  border-radius: 8px;
  display: grid;
  place-items: center;
  color: #0f766e;
  background: #dff7f1;
  border: 1px solid #a7f3d0;
  flex: 0 0 auto;
}

.title-meta,
.section-meta {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 6px;
  font-size: 12px;
  color: #64748b;
}
.title-meta span,
.section-meta span {
  display: inline-flex;
  align-items: center;
  min-height: 20px;
  padding: 0 8px;
  border-radius: 999px;
  background: #eef2f7;
}

.topbar-actions,
.form-actions,
.inline-actions,
.card-actions,
.model-actions,
.action-group,
.instruction-actions,
.inline-tools,
.model-flags {
  display: flex;
  align-items: center;
  gap: 8px;
}

.primary-action,
.secondary-action,
.ghost-action,
.tool-button,
.icon-button,
.icon-action,
.model-action,
.set-default,
.status-pill,
.expand-button,
.doc-link {
  border: 0;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  min-height: 36px;
  padding: 0 12px;
  font-size: 13px;
  font-weight: 650;
  line-height: 1;
  text-decoration: none;
  transition: background 160ms ease, color 160ms ease, border-color 160ms ease, transform 160ms ease;
}

.primary-action {
  background: #111827;
  color: #ffffff;
}
.primary-action:hover {
  background: #0f172a;
}
.primary-action:disabled {
  opacity: 0.55;
}

.secondary-action,
.ghost-action,
.tool-button,
.doc-link {
  background: #ffffff;
  color: #475569;
  border: 1px solid #d8dee8;
}
.secondary-action:hover, .secondary-action.is-active,
.ghost-action:hover,
.ghost-action.is-active,
.tool-button:hover,
.tool-button.is-active,
.doc-link:hover,
.doc-link.is-active {
  background: #eef6ff;
  color: #0b5f59;
  border-color: #99f6e4;
}

.ghost-action {
  background: rgba(255, 255, 255, 0.72);
}

.icon-button,
.icon-action {
  width: 34px;
  min-width: 34px;
  height: 34px;
  min-height: 34px;
  padding: 0;
  background: #ffffff;
  border: 1px solid #d8dee8;
  color: #64748b;
}
.icon-button:hover, .icon-button.is-on,
.icon-action:hover,
.icon-action.is-on {
  background: #eef6ff;
  border-color: #99f6e4;
  color: #0f766e;
}
.icon-button.danger:hover,
.icon-action.danger:hover {
  background: #fff1f2;
  border-color: #fecdd3;
  color: #e11d48;
}

.icon-button.small {
  width: 28px;
  min-width: 28px;
  height: 28px;
  min-height: 28px;
  border-radius: 6px;
}

.signal-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
  margin-bottom: 18px;
}

.signal-card,
.rail-panel,
.editor-panel,
.model-card,
.instruction-card,
.empty-state {
  border: 1px solid #dde3ec;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.05);
}

.signal-card {
  min-height: 108px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.signal-label {
  font-size: 11px;
  font-weight: 750;
  color: #64748b;
  text-transform: uppercase;
}

.signal-value {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
  min-width: 0;
  font-size: 18px;
  line-height: 1.25;
  font-weight: 750;
  color: #0f172a;
  overflow-wrap: anywhere;
}

.signal-sub {
  margin-top: 6px;
  font-size: 12px;
  color: #64748b;
  line-height: 1.4;
  overflow-wrap: anywhere;
}

.status-dot {
  width: 10px;
  height: 10px;
  border-radius: 999px;
  background: #94a3b8;
}
.status-dot.ok {
  background: #10b981;
}
.status-dot.warn {
  background: #f59e0b;
}
.status-dot.danger {
  background: #ef4444;
}

.settings-layout {
  display: grid;
  grid-template-columns: 260px minmax(0, 1fr);
  align-items: start;
  gap: 18px;
}

.settings-rail {
  position: sticky;
  top: 18px;
  display: grid;
  gap: 12px;
}

.rail-panel {
  padding: 10px;
}

.rail-tab {
  width: 100%;
  min-height: 46px;
  display: grid;
  grid-template-columns: 22px 1fr auto;
  align-items: center;
  gap: 10px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: #64748b;
  padding: 0 10px;
  text-align: left;
  font-size: 13px;
  font-weight: 700;
}
.rail-tab small {
  min-width: 24px;
  height: 22px;
  border-radius: 999px;
  display: inline-grid;
  place-items: center;
  padding: 0 7px;
  background: #eef2f7;
  color: #64748b;
  font-size: 11px;
}
.rail-tab.is-active {
  background: #111827;
  color: #ffffff;
}
.rail-tab.is-active small {
  background: rgba(255, 255, 255, 0.16);
  color: #ffffff;
}

.readiness-panel {
  padding: 14px;
}

.panel-heading,
.editor-head,
.section-head,
.model-card-head,
.instruction-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.panel-heading {
  align-items: center;
  margin-bottom: 12px;
  font-size: 13px;
  font-weight: 800;
  color: #111827;
}

.loading-line,
.rail-error {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  border-radius: 8px;
  padding: 10px;
  font-size: 12px;
  line-height: 1.45;
}

.loading-line {
  background: #eef6ff;
  color: #0b5f59;
}

.rail-error {
  background: #fff1f2;
  color: #be123c;
}

.check-list {
  display: grid;
  gap: 10px;
}

.check-item {
  display: grid;
  grid-template-columns: 24px 1fr;
  gap: 9px;
  min-width: 0;
}

.check-icon {
  width: 24px;
  height: 24px;
  border-radius: 7px;
  display: grid;
  place-items: center;
  font-size: 11px;
  background: #e2e8f0;
  color: #475569;
}
.check-icon.ok {
  background: #dcfce7;
  color: #15803d;
}
.check-icon.warn {
  background: #fef3c7;
  color: #b45309;
}
.check-icon.danger {
  background: #ffe4e6;
  color: #e11d48;
}

.check-label {
  font-size: 12px;
  font-weight: 750;
  color: #334155;
}

.check-detail,
.compact-row {
  margin-top: 2px;
  font-size: 11px;
  line-height: 1.45;
  color: #64748b;
}

.compact-list {
  margin-top: 14px;
  border-top: 1px solid #eef2f7;
  padding-top: 12px;
}

.compact-title {
  margin-bottom: 6px;
  font-size: 11px;
  font-weight: 800;
  color: #475569;
  text-transform: uppercase;
}

.chip-cloud {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 14px;
}
.chip-cloud span {
  border-radius: 999px;
  background: #eef2f7;
  color: #475569;
  padding: 5px 8px;
  font-size: 11px;
  font-weight: 650;
}

.settings-main {
  min-width: 0;
}

.section-head {
  align-items: center;
  margin-bottom: 12px;
}
.section-head h2 {
  margin: 0;
  color: #111827;
  font-size: 18px;
  line-height: 1.25;
  font-weight: 800;
}

.provider-url-notice {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  margin-bottom: 14px;
  padding: 13px 14px;
  border: 1px solid #bae6fd;
  border-left: 4px solid #0284c7;
  border-radius: 8px;
  background: #f0f9ff;
  color: #0f172a;
}
.provider-url-notice i {
  margin-top: 2px;
  color: #0284c7;
}
.provider-url-notice strong {
  display: block;
  font-size: 13px;
  font-weight: 800;
}
.provider-url-notice p {
  margin: 4px 0 0;
  color: #475569;
  font-size: 12px;
  line-height: 1.5;
}

.editor-panel {
  padding: 18px;
  margin-bottom: 14px;
}

.editor-head {
  align-items: center;
  margin-bottom: 16px;
}
.editor-head h3 {
  margin: 0;
  font-size: 15px;
  font-weight: 800;
  color: #111827;
}
.editor-head p {
  margin: 4px 0 0;
  font-size: 12px;
  color: #64748b;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.field {
  margin-bottom: 14px;
}
.field label {
  display: block;
  margin-bottom: 7px;
  font-size: 12px;
  font-weight: 750;
  color: #475569;
}

.credential-help {
  display: block;
  margin-top: 7px;
  color: #64748b;
  font-size: 12px;
  line-height: 1.45;
}

.field-label-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 7px;
}
.field-label-row label {
  margin: 0;
}

.secret-field {
  position: relative;
}
.secret-field input {
  padding-right: 48px;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", monospace;
}
.secret-field .icon-button {
  position: absolute;
  top: 3px;
  right: 3px;
}

.form-actions {
  justify-content: flex-end;
  margin-top: 4px;
}
.form-actions.split {
  justify-content: space-between;
  align-items: center;
}

.model-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
  align-items: stretch;
}

.model-card {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 14px;
  min-width: 0;
  min-height: 280px;
  padding: 18px;
  overflow: hidden;
  border-left: 3px solid #14b8a6;
}
.model-card.is-default {
  border-color: #99f6e4;
  border-left-color: #10b981;
  box-shadow: 0 8px 22px rgba(15, 118, 110, 0.08);
}
.model-card.is-codex {
  border-left-color: #38bdf8;
}
.model-card.is-inactive {
  opacity: 0.68;
}

.model-identity {
  display: grid;
  grid-template-columns: 38px minmax(0, 1fr);
  align-items: start;
  gap: 12px;
  min-width: 0;
}

.model-provider-mark {
  width: 38px;
  height: 38px;
  border-radius: 8px;
  display: grid;
  place-items: center;
  background: #ecfdf5;
  color: #0f766e;
  border: 1px solid #99f6e4;
}
.model-provider-mark.codex {
  background: #e0f2fe;
  color: #0369a1;
  border-color: #bae6fd;
}
.model-provider-mark.ollama {
  background: #f8fafc;
  color: #334155;
  border-color: #e2e8f0;
}

.model-heading {
  display: grid;
  gap: 7px;
  min-width: 0;
}

.model-card-head .model-identity {
  flex: 1 1 auto;
}

.model-flags {
  flex: 0 0 auto;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: flex-start;
  max-width: 220px;
}

.provider-badge,
.default-pill,
.status-pill,
.category-pill,
.visibility-pill,
.file-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border-radius: 999px;
  min-height: 24px;
  padding: 0 9px;
  font-size: 11px;
  font-weight: 750;
}

.provider-badge {
  background: #eef2ff;
  color: #3730a3;
}
.provider-badge i {
  font-size: 7px;
}
.provider-badge.ollama {
  background: #f3f4f6;
  color: #111827;
}
.provider-badge.codex {
  background: #e0f2fe;
  color: #075985;
}

.status-pill {
  border: 1px solid transparent;
  min-height: 26px;
  padding: 0 10px;
}
.status-pill.active {
  background: #ecfdf5;
  color: #047857;
}
.status-pill.inactive {
  background: #f1f5f9;
  color: #64748b;
}

.default-pill {
  background: #fef3c7;
  color: #92400e;
}

.set-default {
  min-height: 26px;
  padding: 0 9px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  color: #64748b;
  font-size: 11px;
}
.set-default:hover {
  background: #ecfdf5;
  border-color: #bbf7d0;
  color: #047857;
}

.model-title {
  margin: 0;
  font-size: 16px;
  font-weight: 800;
  line-height: 1.35;
  color: #111827;
  overflow-wrap: anywhere;
}

.model-body {
  display: grid;
  gap: 12px;
  min-width: 0;
  flex: 1 1 auto;
}

.model-code {
  display: grid;
  gap: 6px;
  min-width: 0;
  padding: 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #f8fafc;
}
.model-code span {
  color: #64748b;
  font-size: 11px;
  font-weight: 800;
}
.model-code code {
  color: #0f172a;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", monospace;
  font-size: 13px;
  line-height: 1.45;
  overflow-wrap: anywhere;
  white-space: normal;
}

.model-detail-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}

.model-detail-row {
  min-width: 0;
  padding: 10px 12px;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  background: #ffffff;
  display: grid;
  gap: 5px;
}
.model-detail-row > span {
  color: #71717a;
  font-size: 11px;
  font-weight: 750;
}
.model-detail-row > strong {
  min-width: 0;
  color: #334155;
  font-size: 12px;
  font-weight: 650;
  line-height: 1.45;
  overflow-wrap: anywhere;
}

.credential-row {
  grid-column: 1/-1;
  grid-template-columns: auto minmax(0, 1fr);
  align-items: center;
  gap: 10px;
}

.inline-edit {
  padding: 12px;
  border-radius: 8px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
}
.inline-edit .field {
  margin-bottom: 10px;
}

.secret-value {
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
  color: #64748b;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", monospace;
  font-size: 12px;
}
.secret-value strong,
.secret-value span {
  min-width: 0;
  font-weight: 650;
  line-height: 1.45;
  overflow-wrap: anywhere;
}
.secret-value .is-revealed {
  color: #111827;
}

.card-actions {
  justify-content: flex-end;
  margin-top: 14px;
}

.model-actions {
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: auto;
  padding-top: 14px;
  border-top: 1px solid #f1f5f9;
}

.model-action {
  min-height: 30px;
  padding: 0 10px;
  border: 1px solid #e4e4e7;
  border-radius: 6px;
  background: #ffffff;
  color: #52525b;
}
.model-action:hover {
  background: #ecfdf5;
  border-color: #99f6e4;
  color: #0f766e;
}
.model-action.danger:hover {
  background: #fff1f2;
  border-color: #fecdd3;
  color: #e11d48;
}

.empty-state {
  min-height: 220px;
  display: grid;
  place-items: center;
  align-content: center;
  gap: 9px;
  padding: 36px 18px;
  color: #64748b;
  text-align: center;
}
.empty-state i {
  font-size: 28px;
  color: #94a3b8;
}
.empty-state strong {
  color: #334155;
  font-size: 14px;
}
.empty-state span {
  max-width: 360px;
  font-size: 12px;
  line-height: 1.55;
}

.segmented-control {
  display: inline-flex;
  flex-wrap: wrap;
  gap: 6px;
  padding: 4px;
  border-radius: 8px;
  background: #eef2f7;
}
.segmented-control label {
  min-height: 32px;
  margin: 0;
  border-radius: 7px;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 0 10px;
  color: #64748b;
  font-size: 12px;
  font-weight: 750;
  cursor: pointer;
}
.segmented-control label input {
  display: none;
}
.segmented-control label.is-active {
  background: #ffffff;
  color: #111827;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.12);
}

.guide-editor {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", monospace;
}

.guide-preview {
  min-height: 280px;
  max-height: 520px;
  overflow: auto;
  border: 1px solid #d6dbe3;
  border-radius: 8px;
  background: #ffffff;
  padding: 16px;
}

.file-chip {
  width: fit-content;
  margin-bottom: 8px;
  background: #eef6ff;
  color: #0b5f59;
}

.toggle-line {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #475569;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
}
.toggle-line input {
  width: 16px;
  height: 16px;
  min-height: 16px;
  padding: 0;
}

.instruction-list {
  display: grid;
  gap: 12px;
}

.instruction-card {
  padding: 16px;
  border-left: 4px solid #0f766e;
}
.instruction-card.is-inactive {
  border-left-color: #cbd5e1;
  opacity: 0.72;
}

.instruction-title-line {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  min-width: 0;
}
.instruction-title-line h3 {
  margin: 0;
  color: #111827;
  font-size: 15px;
  line-height: 1.3;
  font-weight: 800;
  overflow-wrap: anywhere;
}

.category-pill.analysis {
  background: #dbeafe;
  color: #0b5f59;
}
.category-pill.proposal {
  background: #dcfce7;
  color: #15803d;
}
.category-pill.presentation {
  background: #eef2ff;
  color: #4338ca;
}
.category-pill.chat {
  background: #fef3c7;
  color: #b45309;
}
.category-pill.general {
  background: #f1f5f9;
  color: #475569;
}

.visibility-pill {
  background: #f1f5f9;
  color: #64748b;
}
.visibility-pill.public {
  background: #ccfbf1;
  color: #0f766e;
}

.file-type {
  color: #ef4444;
  font-size: 12px;
}

.source-line {
  display: flex;
  align-items: center;
  gap: 7px;
  margin-top: 10px;
  color: #64748b;
  font-size: 12px;
}

.instruction-preview {
  margin-top: 12px;
  cursor: pointer;
}
.instruction-preview.is-collapsed {
  max-height: 120px;
  overflow: hidden;
  position: relative;
}
.instruction-preview.is-collapsed::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 42px;
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0), #ffffff);
  pointer-events: none;
}

.expand-button {
  min-height: 30px;
  margin-top: 8px;
  padding: 0 10px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  color: #64748b;
  font-size: 12px;
}
.expand-button:hover {
  background: #eef6ff;
  color: #0b5f59;
}

.markdown-preview {
  font-size: 13px;
  line-height: 1.7;
  color: #334155;
}
.markdown-preview h1, .markdown-preview h2, .markdown-preview h3, .markdown-preview h4, .markdown-preview h5, .markdown-preview h6 {
  font-weight: 750;
  margin-top: 1em;
  margin-bottom: 0.5em;
  color: #111827;
}
.markdown-preview h1 {
  font-size: 1.35em;
}
.markdown-preview h2 {
  font-size: 1.18em;
}
.markdown-preview h3 {
  font-size: 1.08em;
}
.markdown-preview p {
  margin-bottom: 0.65em;
}
.markdown-preview ul, .markdown-preview ol {
  padding-left: 1.5em;
  margin-bottom: 0.65em;
}
.markdown-preview li {
  margin-bottom: 0.25em;
}
.markdown-preview code {
  background: #eef2f7;
  padding: 1px 4px;
  border-radius: 4px;
  font-size: 0.9em;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", monospace;
}
.markdown-preview pre {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 12px;
  overflow-x: auto;
  margin-bottom: 0.8em;
}
.markdown-preview pre code {
  background: none;
  padding: 0;
}
.markdown-preview blockquote {
  border-left: 3px solid #cbd5e1;
  padding-left: 12px;
  color: #64748b;
  margin: 0.7em 0;
}
.markdown-preview table {
  border-collapse: collapse;
  width: 100%;
  margin-bottom: 0.8em;
}
.markdown-preview table th, .markdown-preview table td {
  border: 1px solid #e2e8f0;
  padding: 6px 10px;
  text-align: left;
}
.markdown-preview table th {
  background: #f8fafc;
  font-weight: 750;
}
.markdown-preview a {
  color: #0f766e;
  text-decoration: underline;
}
.markdown-preview hr {
  border: 0;
  border-top: 1px solid #e2e8f0;
  margin: 1em 0;
}

.markdown-preview-sm {
  font-size: 12px;
}
.markdown-preview-sm h1 {
  font-size: 1.12em;
}
.markdown-preview-sm h2 {
  font-size: 1.04em;
}
.markdown-preview-sm h3 {
  font-size: 1em;
}

@media (max-width: 1080px) {
  .signal-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .settings-layout {
    grid-template-columns: 1fr;
  }
  .settings-rail {
    position: static;
    grid-template-columns: minmax(0, 1fr);
  }
  .rail-panel:first-child {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
  }
}
@media (max-width: 760px) {
  .settings-shell {
    padding: 18px 14px 30px;
  }
  .settings-topbar,
  .section-head,
  .editor-head,
  .model-card-head,
  .instruction-head,
  .form-actions.split {
    align-items: stretch;
    flex-direction: column;
  }
  .topbar-actions,
  .action-group {
    width: 100%;
    flex-wrap: wrap;
  }
  .topbar-actions > *,
  .action-group > * {
    flex: 1 1 auto;
  }
  .signal-grid,
  .model-grid,
  .model-detail-grid,
  .form-grid,
  .rail-panel:first-child {
    grid-template-columns: 1fr;
  }
  .credential-row {
    align-items: flex-start;
    grid-template-columns: 1fr;
  }
  .secret-value {
    justify-content: flex-start;
  }
  .model-actions {
    justify-content: flex-start;
  }
}
/* Library-tone compact overrides */
.ai-settings {
  background: #fafafa;
  color: #18181b;
}
.ai-settings input, .ai-settings select {
  min-height: 32px;
  border-color: #e4e4e7;
  border-radius: 6px;
  font-size: 12px;
}
.ai-settings textarea {
  border-color: #e4e4e7;
  border-radius: 6px;
  font-size: 12px;
}
.ai-settings input:focus, .ai-settings select:focus, .ai-settings textarea:focus {
  border-color: #99f6e4;
  box-shadow: 0 0 0 3px rgba(15, 118, 110, 0.08);
}

.settings-shell {
  max-width: 1400px;
  padding: 20px 24px 60px;
}

.settings-topbar {
  align-items: flex-start;
  padding-bottom: 12px;
  margin-bottom: 16px;
  border-bottom: 1px solid #e4e4e7;
}

.topbar-title {
  gap: 8px;
}
.topbar-title h1 {
  font-size: 17px;
  font-weight: 700;
}

.title-mark {
  width: 28px;
  height: 28px;
  border-radius: 6px;
  color: #0f766e;
  background: #ecfdf5;
  border-color: #99f6e4;
  font-size: 12px;
}

.title-meta,
.section-meta {
  gap: 5px;
  margin-top: 4px;
  font-size: 11px;
}
.title-meta span,
.section-meta span {
  min-height: 18px;
  padding: 0 7px;
  background: #f4f4f5;
  color: #71717a;
}

.primary-action,
.secondary-action,
.ghost-action,
.tool-button,
.icon-button,
.icon-action,
.model-action,
.set-default,
.status-pill,
.expand-button,
.doc-link {
  min-height: 32px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
}

.primary-action {
  background: #0f766e;
}
.primary-action:hover {
  background: #0b5f59;
}

.secondary-action,
.ghost-action,
.tool-button,
.doc-link {
  border-color: #e4e4e7;
  color: #52525b;
}
.secondary-action:hover, .secondary-action.is-active,
.ghost-action:hover,
.ghost-action.is-active,
.tool-button:hover,
.tool-button.is-active,
.doc-link:hover,
.doc-link.is-active {
  background: #ecfdf5;
  color: #0f766e;
  border-color: #99f6e4;
}

.icon-button,
.icon-action {
  width: 30px;
  min-width: 30px;
  height: 30px;
  min-height: 30px;
  border-color: #e4e4e7;
}

.signal-grid {
  gap: 8px;
  margin-bottom: 12px;
}

.signal-card,
.rail-panel,
.editor-panel,
.model-card,
.instruction-card,
.empty-state {
  border-color: #e4e4e7;
  box-shadow: none;
}

.signal-card {
  min-height: 86px;
  padding: 12px;
}

.signal-label {
  color: #71717a;
  font-size: 11px;
  font-weight: 600;
  text-transform: none;
}

.signal-value {
  margin-top: 8px;
  font-size: 15px;
  font-weight: 700;
}

.signal-sub {
  margin-top: 4px;
  font-size: 11px;
}

.settings-layout {
  grid-template-columns: 240px minmax(0, 1fr);
  gap: 12px;
}

.settings-rail {
  gap: 8px;
}

.rail-panel {
  padding: 8px;
}

.rail-tab {
  min-height: 38px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
}
.rail-tab.is-active {
  background: #ecfdf5;
  color: #0f766e;
}
.rail-tab.is-active small {
  background: #0f766e;
  color: #fff;
}

.readiness-panel {
  padding: 12px;
}

.panel-heading {
  margin-bottom: 10px;
  font-size: 12px;
  font-weight: 700;
}

.check-item {
  grid-template-columns: 22px 1fr;
  gap: 8px;
}

.check-icon {
  width: 22px;
  height: 22px;
  border-radius: 6px;
}

.check-label {
  font-size: 12px;
  font-weight: 650;
}

.check-detail,
.compact-row {
  font-size: 11px;
}

.section-head {
  margin-bottom: 10px;
}
.section-head h2 {
  font-size: 15px;
  font-weight: 700;
}

.editor-panel {
  padding: 14px;
  margin-bottom: 12px;
}

.editor-head {
  margin-bottom: 12px;
}
.editor-head h3 {
  font-size: 14px;
  font-weight: 700;
}

.model-card,
.instruction-card {
  border-radius: 8px;
}

@media (max-width: 1080px) {
  .settings-layout {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 760px) {
  .settings-shell {
    padding: 18px 14px 40px;
  }
}
/* Font scale refinement */
.ai-settings {
  font-size: 12px;
}
.ai-settings input, .ai-settings select, .ai-settings textarea {
  font-size: 11.5px;
}

.topbar-title h1 {
  font-size: 16px;
}

.title-meta,
.section-meta,
.signal-label,
.signal-sub,
.check-detail,
.compact-row {
  font-size: 11px;
}

.signal-value {
  font-size: 14px;
}

.primary-action,
.secondary-action,
.ghost-action,
.tool-button,
.model-action,
.set-default,
.status-pill,
.expand-button,
.doc-link,
.rail-tab {
  font-size: 11.5px;
}

.section-head h2 {
  font-size: 14px;
}

.editor-head h3 {
  font-size: 13px;
}

/* Simple top tab bar */
.settings-tabs {
  display: flex;
  gap: 2px;
  margin: -4px 0 16px;
  border-bottom: 1px solid #e4e4e7;
  overflow-x: auto;
}

.settings-tab {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  height: 38px;
  padding: 0 14px;
  border: 0;
  border-bottom: 2px solid transparent;
  background: transparent;
  color: #71717a;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}

.settings-tab:hover {
  background: #f4f4f5;
  color: #18181b;
}

.settings-tab.is-active {
  border-bottom-color: #0f766e;
  background: rgba(236, 253, 245, 0.55);
  color: #0f766e;
}

.settings-tab em {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 28px;
  height: 18px;
  padding: 0 7px;
  border-radius: 999px;
  background: #f4f4f5;
  color: #52525b;
  font-size: 10.5px;
  font-style: normal;
  font-weight: 700;
}

.settings-tab.is-active em {
  background: #0f766e;
  color: #ffffff;
}

.settings-layout {
  grid-template-columns: 1fr;
}

.settings-rail {
  display: none;
}

@media (max-width: 760px) {
  .settings-tabs {
    margin-bottom: 12px;
  }
}
/* Guide management overflow/layout fix */
.ai-settings,
.settings-shell,
.settings-layout,
.settings-main,
.instructions-section,
.editor-panel,
.instruction-list,
.instruction-card {
  max-width: 100%;
  min-width: 0;
}

.settings-shell {
  overflow-x: hidden;
}

.settings-tabs {
  overflow-x: visible;
}

.settings-tab {
  flex: 0 1 auto;
}

.instructions-section {
  display: grid;
  gap: 12px;
}

.instructions-section .section-head,
.instructions-section .editor-head,
.instruction-head,
.form-actions.split,
.field-label-row {
  min-width: 0;
}

.instructions-section .section-head {
  align-items: center;
}

.instructions-section .section-head > div,
.editor-head > div {
  min-width: 0;
}

.editor-panel {
  overflow: hidden;
}

.form-grid {
  width: 100%;
  min-width: 0;
}

.field {
  min-width: 0;
}

.field-label-row {
  flex-wrap: wrap;
}

.inline-tools,
.action-group,
.instruction-actions {
  flex-wrap: wrap;
  min-width: 0;
}

.segmented-control {
  max-width: 100%;
}

.guide-editor,
.guide-preview {
  width: 100%;
  max-width: 100%;
  min-width: 0;
}

.guide-preview {
  overflow-x: hidden;
}

.instruction-list {
  gap: 8px;
}

.instruction-card {
  padding: 13px 14px;
  overflow: hidden;
  border-left-width: 3px;
}

.instruction-head {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: start;
  gap: 10px;
}

.instruction-title-line {
  display: flex;
  min-width: 0;
  max-width: 100%;
  gap: 6px;
}

.instruction-title-line h3 {
  min-width: 0;
  max-width: 100%;
  font-size: 13px;
  font-weight: 650;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.category-pill,
.visibility-pill,
.file-chip {
  max-width: 100%;
  min-width: 0;
  flex: 0 1 auto;
  font-weight: 600;
}

.file-chip span,
.source-line span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.instruction-actions {
  justify-content: flex-end;
  gap: 5px;
}

.instruction-actions .icon-button {
  width: 28px;
  min-width: 28px;
  height: 28px;
  min-height: 28px;
}

.source-line {
  min-width: 0;
  max-width: 100%;
}

.instruction-preview {
  max-width: 100%;
  overflow-x: hidden;
}

.markdown-preview {
  max-width: 100%;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.markdown-preview * {
  max-width: 100%;
}

.markdown-preview pre {
  max-width: 100%;
  overflow-x: auto;
  white-space: pre-wrap;
  word-break: break-word;
}

.markdown-preview code {
  white-space: pre-wrap;
  word-break: break-word;
}

.markdown-preview table {
  display: block;
  max-width: 100%;
  overflow-x: auto;
}

@media (max-width: 760px) {
  .settings-tabs {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    overflow: visible;
  }
  .settings-tab {
    justify-content: center;
    min-width: 0;
    padding: 0 8px;
  }
  .settings-tab span {
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .instructions-section .section-head,
  .instruction-head,
  .form-actions.split {
    display: grid;
    grid-template-columns: 1fr;
  }
  .instruction-actions,
  .action-group {
    justify-content: flex-start;
  }
  .instruction-title-line h3 {
    white-space: normal;
  }
}`],
})
export class PageSettingsAiComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public tab: string = 'models';
    public providers: any[] = [];
    public instructions: any[] = [];
    public loading: boolean = false;
    public showNewApiKey: boolean = false;
    public showEditApiKey: boolean = false;
    public revealedProviderKeys: any = {};
    public revealingProviderId: string = '';

    // 모델 추가 폼
    public showAddModel: boolean = false;
    public newModel: any = { provider: 'ollama', model_id: '', display_name: '', api_key: '' };

    // 모델 ID 편집 (인라인 수정)
    public editingProviderId: string = '';
    public editProviderForm: any = { model_id: '', display_name: '', api_key: '' };

    // 제공사별 모델 도큐멘트 링크
    public providerDocLinks: any = {
        ollama: 'https://github.com/ollama/ollama/blob/main/docs/api.md',
    };

    // 인스트럭션 추가/편집
    public showAddInstruction: boolean = false;
    public editingInstruction: any = null;
    public instructionForm: any = { title: '', category: 'analysis', content: '', is_active: true, visibility: 'private' };
    public previewMode: boolean = false;
    public uploadedFileName: string = '';
    public expandedInstructions: any = {};

    public categories: any[] = [
        { value: 'analysis', label: 'RFP 분석' },
        { value: 'proposal', label: '제안서 작성' },
        { value: 'presentation', label: '발표자료' },
        { value: 'chat', label: 'AI 어시스턴트' },
        { value: 'general', label: '공통' },
    ];

    public providerOptions: any[] = [
        { value: 'ollama', label: 'Qwen 내부 모델', models: ['qwen3.6:35b-a3b'] },
        { value: 'codex', label: 'Codex', models: ['codex'] },
    ];

    public async ngOnInit() {
        await this.service.init();
        await this.reloadSettingsData(true, true);
        await this.service.render();
    }

    public async reloadSettingsData(loadProviders: boolean = true, loadInstructions: boolean = true) {
        if (loadProviders) {
            await this.loadProviders();
        }
        if (loadInstructions) {
            await this.loadInstructions();
        }
    }

    public async loadProviders() {
        let res = await wiz.call("load_providers");
        if (res.code === 200) {
            this.providers = res.data.providers || [];
            this.revealedProviderKeys = {};
        }
    }

    public async loadInstructions() {
        let res = await wiz.call("load_instructions");
        if (res.code === 200) {
            this.instructions = res.data.instructions || [];
        }
    }

    public get activeProviderCount(): number {
        return this.providers.filter((p: any) => p?.status === 'active').length;
    }

    public get activeInstructionCount(): number {
        return this.instructions.filter((inst: any) => !!inst?.is_active).length;
    }

    public async switchTab(tab: string) {
        this.tab = tab;
        await this.service.render();
    }

    // =================== 모델 관리 ===================

    public getProviderModels() {
        let opt = this.providerOptions.find(p => p.value === this.newModel.provider);
        return opt ? opt.models : [];
    }

    public getProviderLabel(provider: string) {
        let opt = this.providerOptions.find(p => p.value === provider);
        return opt ? opt.label : provider;
    }

    public async onNewProviderChange(provider: string) {
        this.newModel.provider = provider;
        this.newModel.model_id = '';
        this.newModel.display_name = '';
        this.newModel.api_key = '';
        this.showNewApiKey = false;
        await this.service.render();
    }

    public isProviderUrlCredential(provider: string): boolean {
        return provider === 'ollama';
    }

    public isCredentialRequired(provider: string): boolean {
        return provider !== 'codex';
    }

    public getCredentialLabel(provider: string): string {
        if (provider === 'codex') return 'Device-code 인증';
        return this.isProviderUrlCredential(provider) ? 'LLM Provider URL' : 'API Key';
    }

    public getCredentialShortLabel(provider: string): string {
        if (provider === 'codex') return '인증 상태';
        return this.isProviderUrlCredential(provider) ? 'Provider URL' : 'API Key';
    }

    public getCredentialPlaceholder(provider: string): string {
        if (provider === 'codex') {
            return '서버의 codex login 상태를 사용합니다';
        }
        if (this.isProviderUrlCredential(provider)) {
            return '예: http://220.82.71.5:11434 또는 https://llm.example.com/v1?api_key=...';
        }
        return 'API Key 입력';
    }

    public getEditCredentialPlaceholder(provider: string): string {
        if (provider === 'codex') return 'Codex는 API Key가 필요 없습니다';
        return this.isProviderUrlCredential(provider)
            ? '입력하면 기존 Provider URL 교체'
            : '입력하면 기존 API Key 교체';
    }

    public getCredentialHelp(provider: string): string {
        if (provider === 'codex') {
            return 'API Key 없이 서버의 Codex device-code 인증을 사용합니다. 연결 테스트로 인증 상태를 확인하세요.';
        }
        if (this.isProviderUrlCredential(provider)) {
            return '회사 Ollama는 별도 API Key 없이 LLM Provider URL로 연결합니다. 보안 설정이 붙은 vLLM/OpenAI-compatible 엔드포인트는 토큰이 포함된 URL을 입력할 수 있습니다.';
        }
        return '외부 LLM 호출에 필요한 API Key입니다. 저장 시 암호화되고 목록에서는 마스킹됩니다.';
    }

    public getCredentialRequiredMessage(provider: string): string {
        if (provider === 'codex') return '모델을 선택해주세요.';
        return this.isProviderUrlCredential(provider)
            ? '모델과 LLM Provider URL을 입력해주세요.'
            : '모델과 API Key를 입력해주세요.';
    }

    public async openAddModel() {
        this.newModel = { provider: 'ollama', model_id: '', display_name: '', api_key: '' };
        this.showNewApiKey = false;
        this.showAddModel = true;
        await this.service.render();
    }

    public async cancelAddModel() {
        this.showAddModel = false;
        this.showNewApiKey = false;
        await this.service.render();
    }

    public async saveModel() {
        if (!this.newModel.model_id || (this.isCredentialRequired(this.newModel.provider) && !this.newModel.api_key)) {
            await this.service.modal.show({
                title: '', message: this.getCredentialRequiredMessage(this.newModel.provider),
                cancel: false, action: '확인', actionBtn: 'error', status: 'error'
            });
            return;
        }
        if (!this.newModel.display_name) {
            let provLabel = this.getProviderLabel(this.newModel.provider);
            this.newModel.display_name = `${provLabel} ${this.newModel.model_id}`;
        }
        this.loading = true;
        await this.service.render();

        let res = await wiz.call("save_provider", this.newModel);
        this.loading = false;
        if (res.code === 200) {
            this.showAddModel = false;
            this.showNewApiKey = false;
            await this.reloadSettingsData(true, false);
        } else {
            await this.service.modal.show({
                title: '', message: res.data?.message || '저장 실패',
                cancel: false, action: '확인', actionBtn: 'error', status: 'error'
            });
        }
        await this.service.render();
    }

    public async toggleNewApiKeyVisibility() {
        this.showNewApiKey = !this.showNewApiKey;
        await this.service.render();
    }

    public async toggleEditApiKeyVisibility() {
        this.showEditApiKey = !this.showEditApiKey;
        await this.service.render();
    }

    public displayProviderApiKey(provider: any): string {
        if (!provider) return '-';
        if (provider.provider === 'codex') return provider.has_api_key ? 'device-code 인증' : '인증 확인 필요';
        if (this.revealedProviderKeys[provider.id]) {
            return this.revealedProviderKeys[provider.id];
        }
        return provider.api_key_masked || (provider.has_api_key ? '••••••' : '-');
    }

    public isProviderKeyRevealed(provider: any): boolean {
        return !!this.revealedProviderKeys[provider?.id];
    }

    public async toggleProviderKey(provider: any) {
        if (provider?.provider === 'codex') return;
        if (!provider?.id || !provider.has_api_key) return;

        if (this.revealedProviderKeys[provider.id]) {
            delete this.revealedProviderKeys[provider.id];
            await this.service.render();
            return;
        }

        this.revealingProviderId = provider.id;
        await this.service.render();

        let res = await wiz.call('reveal_provider_key', { id: provider.id });
        this.revealingProviderId = '';

        if (res.code === 200) {
            this.revealedProviderKeys[provider.id] = res.data?.api_key || '';
        } else {
            await this.service.modal.show({
                title: '', message: res.data?.message || '접속 정보 조회 실패',
                cancel: false, action: '확인', actionBtn: 'error', status: 'error'
            });
        }

        await this.service.render();
    }

    public async setDefault(provider: any) {
        let res = await wiz.call("set_default_provider", { id: provider.id });
        if (res.code === 200) {
            await this.reloadSettingsData(true, false);
            await this.service.render();
        }
    }

    public async toggleProviderStatus(provider: any) {
        let newStatus = provider.status === 'active' ? 'inactive' : 'active';
        let res = await wiz.call("update_provider_status", { id: provider.id, status: newStatus });
        if (res.code === 200) {
            await this.reloadSettingsData(true, false);
            await this.service.render();
        }
    }

    public async deleteProvider(provider: any) {
        let ok = await this.service.modal.show({
            title: '모델 삭제',
            message: `"${provider.display_name}" 모델을 삭제하시겠습니까?`,
            action: '삭제',
            actionBtn: 'error',
            status: 'error'
        });
        if (!ok) return;

        let res = await wiz.call("delete_provider", { id: provider.id });
        if (res.code === 200) {
            await this.reloadSettingsData(true, false);
            await this.service.render();
        }
    }

    public async testProvider(provider: any) {
        this.loading = true;
        await this.service.render();
        let res = await wiz.call("test_provider", { id: provider.id });
        this.loading = false;
        if (res.code === 200) {
            await this.service.modal.show({
                title: '', message: '연결 테스트 성공! AI가 정상적으로 응답했습니다.',
                cancel: false, action: '확인', actionBtn: 'success', status: 'success'
            });
        } else {
            await this.service.modal.show({
                title: '', message: `연결 실패: ${res.data?.message || '알 수 없는 오류'}`,
                cancel: false, action: '확인', actionBtn: 'error', status: 'error'
            });
        }
        await this.service.render();
    }

    public maskApiKey(key: string) {
        if (!key || key.length < 12) return '****';
        return key.substring(0, 6) + '••••••' + key.substring(key.length - 4);
    }

    public getProviderDocLink(provider: string): string {
        return this.providerDocLinks[provider] || '';
    }

    public openProviderDocs(provider: string, event?: Event) {
        if (event) event.stopPropagation();
        const url = this.getProviderDocLink(provider);
        if (url) window.open(url, '_blank', 'noopener');
    }

    // ── 모델 ID 편집 ──
    public async startEditProvider(p: any) {
        this.editingProviderId = p.id;
        this.showEditApiKey = false;
        this.editProviderForm = {
            model_id: p.model_id || '',
            display_name: p.display_name || '',
            api_key: ''
        };
        await this.service.render();
    }

    public async cancelEditProvider() {
        this.editingProviderId = '';
        this.showEditApiKey = false;
        this.editProviderForm = { model_id: '', display_name: '', api_key: '' };
        await this.service.render();
    }

    public async saveEditProvider(p: any) {
        const newId = (this.editProviderForm.model_id || '').trim();
        if (!newId) {
            await this.service.modal.show({
                title: '', message: '모델 ID를 입력해주세요.',
                cancel: false, action: '확인', actionBtn: 'error', status: 'error'
            });
            return;
        }
        this.loading = true;
        await this.service.render();

        let res = await wiz.call('update_provider_model', {
            id: p.id,
            model_id: newId,
            display_name: this.editProviderForm.display_name || '',
            api_key: (this.editProviderForm.api_key || '').trim()
        });
        this.loading = false;

        if (res.code === 200) {
            this.editingProviderId = '';
            this.showEditApiKey = false;
            delete this.revealedProviderKeys[p.id];
            await this.reloadSettingsData(true, false);
        } else {
            await this.service.modal.show({
                title: '', message: res.data?.message || '변경 실패',
                cancel: false, action: '확인', actionBtn: 'error', status: 'error'
            });
        }
        await this.service.render();
    }

    // =================== 인스트럭션 관리 ===================

    public getCategoryLabel(cat: string) {
        let c = this.categories.find(x => x.value === cat);
        return c ? c.label : cat;
    }

    public async openAddInstruction() {
        this.editingInstruction = null;
        this.instructionForm = { title: '', category: 'analysis', content: '', is_active: true, visibility: 'private' };
        this.previewMode = false;
        this.uploadedFileName = '';
        this.showAddInstruction = true;
        await this.service.render();
    }

    public async editInstruction(inst: any) {
        this.editingInstruction = inst;
        this.instructionForm = {
            title: inst.title,
            category: inst.category,
            content: inst.content,
            is_active: inst.is_active,
            visibility: inst.visibility || 'private'
        };
        this.showAddInstruction = true;
        await this.service.render();
    }

    public async cancelInstruction() {
        this.showAddInstruction = false;
        this.editingInstruction = null;
        this.previewMode = false;
        this.uploadedFileName = '';
        await this.service.render();
    }

    public async saveInstruction() {
        if (!this.instructionForm.title || !this.instructionForm.content) {
            await this.service.modal.show({
                title: '', message: '제목과 내용을 입력해주세요.',
                cancel: false, action: '확인', actionBtn: 'error', status: 'error'
            });
            return;
        }

        this.loading = true;
        await this.service.render();

        let data: any = { ...this.instructionForm };
        if (this.editingInstruction) {
            data.id = this.editingInstruction.id;
        }

        let res = await wiz.call("save_instruction", data);
        this.loading = false;

        if (res.code === 200) {
            this.showAddInstruction = false;
            this.editingInstruction = null;
            await this.reloadSettingsData(false, true);
        } else {
            await this.service.modal.show({
                title: '', message: res.data?.message || '저장 실패',
                cancel: false, action: '확인', actionBtn: 'error', status: 'error'
            });
        }
        await this.service.render();
    }

    public async toggleInstruction(inst: any) {
        let res = await wiz.call("toggle_instruction", { id: inst.id, is_active: !inst.is_active });
        if (res.code === 200) {
            await this.reloadSettingsData(false, true);
            await this.service.render();
        }
    }

    public async toggleVisibility(inst: any) {
        let res = await wiz.call("toggle_visibility", { id: inst.id });
        if (res.code === 200) {
            await this.reloadSettingsData(false, true);
            await this.service.render();
        }
    }

    public async uploadFileToForm() {
        const input = document.createElement('input');
        input.type = 'file';
        input.accept = '.md,.pdf';
        input.onchange = async (e: any) => {
            const file = e.target.files?.[0];
            if (!file) return;

            const fd = new FormData();
            fd.append('file[]', file);

            this.loading = true;
            await this.service.render();

            let res: any;
            try {
                const url = wiz.url("extract_file_content");
                const response = await fetch(url, { method: 'POST', body: fd });
                res = await response.json();
            } catch (err) {
                res = { code: 500, data: { message: '파일 업로드 실패' } };
            }
            this.loading = false;

            if (res.code === 200) {
                this.instructionForm.content = res.data.content || '';
                this.uploadedFileName = res.data.filename || file.name;
                if (!this.instructionForm.title) {
                    this.instructionForm.title = res.data.filename?.replace(/\.[^.]+$/, '') || '';
                }
                this.previewMode = true;
            } else {
                await this.service.modal.show({
                    title: '', message: res.data?.message || '파일 읽기 실패',
                    cancel: false, action: '확인', actionBtn: 'error', status: 'error'
                });
            }
            await this.service.render();
        };
        input.click();
    }

    public async togglePreview() {
        this.previewMode = !this.previewMode;
        await this.service.render();
    }

    public renderMarkdown(text: string) {
        if (!text) return '';
        let converter = new showdown.Converter({ tables: true, ghCodeBlocks: true, tasklists: true, strikethrough: true });
        return converter.makeHtml(text);
    }

    public async toggleExpand(inst: any) {
        this.expandedInstructions[inst.id] = !this.expandedInstructions[inst.id];
        await this.service.render();
    }

    public async deleteInstruction(inst: any) {
        let ok = await this.service.modal.show({
            title: '가이드 삭제',
            message: `"${inst.title}" 가이드를 삭제하시겠습니까?`,
            action: '삭제',
            actionBtn: 'error',
            status: 'error'
        });
        if (!ok) return;

        let res = await wiz.call("delete_instruction", { id: inst.id });
        if (res.code === 200) {
            await this.reloadSettingsData(false, true);
            await this.service.render();
        }
    }
}

export default PageSettingsAiComponent;